var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBooks = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 5.022C10.875 3.944 12 6.1 12 6.1s1.125-2.156 9-1.078V17.96c-6.75-1.078-9 .539-9 .539s-2.25-1.617-9-.54V5.023ZM12 20V5",
  stroke: "currentColor",
  strokeWidth: 2
})));
export default SvgBooks;